import React from "react";
import './text.css';


const TextPage = (props) =>
{
return(<div className="textPage">
   

    <div className="container">
        <div className="row">
            <div className="col-md-12">
            <h1>{props.text.displayName}</h1>
                <div className="introduction">
                  <p>{props.text.description}</p>
                 </div>
                 {props.text.items!==null?props.text.items.map((item,index) => (
                      <div className="text-wrap" key={index}>
                         <div className="text-head">
                         <h5>{item.itemRef}</h5>
                         </div>
                         
                          <div className="text-para">
                          <p >{item.itemid}</p>

                          </div>
                          

                       </div>
                     )):""}
            </div>
        </div>
    </div>


</div>)
}

export default TextPage;